// extracted by mini-css-extract-plugin
export default {"container":"Storage_container__CQLlh","storage":"Storage_storage__oV9bG","content":"Storage_content__2V9WB"};